export default {
  title: {
    en: 'An internal error has occurred.',
  },
}
